import { logDebugCacheEvent } from '@office-start/instrumentation-service';
import { initializeOTel, initializeUnAuthOTel, sendEvent, sendUnAuthEvent, } from '@office-start/otel-telemetry-service';
import { initializeTelemetryService } from './TelemetryService';
export function initializeOTelTelemetryService(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, eventCategoryConfig, identity, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userSegment, getCurrentRoute) {
    initializeOTel(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, identity, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userSegment)
        .then(function () {
        initializeTelemetryService([
            {
                // Otel
                logEvent: sendEvent,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                flush: function () { },
            },
        ], getCurrentRoute, eventCategoryConfig);
    })
        .catch(function (error) {
        var _a;
        var _b;
        // TODO: Should change to use OTEL error logging once API is available
        var params = (_a = {},
            _a["Error" /* Error */] = ((_b = error === null || error === void 0 ? void 0 : error.toString) === null || _b === void 0 ? void 0 : _b.call(error)) || '',
            _a);
        logDebugCacheEvent('OTEL_Initialization_Error', params);
    });
}
export function initializeUnAuthOTelTelemetryService(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, eventCategoryConfig, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userType, getCurrentRoute) {
    initializeUnAuthOTel(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userType);
    initializeTelemetryService([
        {
            // Otel
            logEvent: sendUnAuthEvent,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            flush: function () { },
        },
    ], getCurrentRoute, eventCategoryConfig);
}
//# sourceMappingURL=initializeOtelTelemetryService.js.map